/* eslint-disable import/prefer-default-export */

import React from 'react';
import { ThemeProvider, useTheme } from 'styled-components';
import theme from './src/layout/theme';

const WrapPageElementComponent = ({ element, props }) => {
  const parentTheme = useTheme();
  return (
    <ThemeProvider theme={{ ...parentTheme, pages: theme }} {...props}>
      {element}
    </ThemeProvider>
  );
};

export const wrapPageElement = (props) => <WrapPageElementComponent {...props} />;
